var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.5C24.8366 32.5 32 25.3366 32 16.5C32 7.66344 24.8366 0.5 16 0.5C7.16344 0.5 0 7.66344 0 16.5C0 25.3366 7.16344 32.5 16 32.5Z",
    fill: "url(#paint0_linear_14_174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6875 10.875C20.6875 8.29031 18.5847 6.1875 16 6.1875C13.4153 6.1875 11.3125 8.29031 11.3125 10.875C11.3125 13.4597 13.4153 15.5625 16 15.5625C18.5847 15.5625 20.6875 13.4597 20.6875 10.875ZM16 15.5625C11.3476 15.5625 7.5625 19.3476 7.5625 24V24.8786C7.5625 25.1451 7.67587 25.399 7.87437 25.5768C10.158 27.6231 13.0437 28.75 16 28.75C18.9563 28.75 21.8421 27.6231 24.1256 25.5768C24.3241 25.399 24.4375 25.1451 24.4375 24.8786V24C24.4375 19.3476 20.6524 15.5625 16 15.5625Z",
    fill: "url(#paint1_linear_14_174)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_174",
    x1: 16,
    y1: 32.5,
    x2: 16,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5558FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_174",
    x1: 16,
    y1: 28.75,
    x2: 16,
    y2: 6.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/ICON_AVATAR.f59380f79adbf25036320b817c8d9785.svg";
export { ForwardRef as ReactComponent };